export const InfoToolTip = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18797_18328)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 5.91333C8.27614 5.91333 8.5 6.13719 8.5 6.41333V11.9133C8.5 12.1895 8.27614 12.4133 8 12.4133C7.72386 12.4133 7.5 12.1895 7.5 11.9133V6.41333C7.5 6.13719 7.72386 5.91333 8 5.91333ZM8 4.91333C8.36819 4.91333 8.66667 4.61485 8.66667 4.24666C8.66667 3.87847 8.36819 3.58 8 3.58C7.63181 3.58 7.33333 3.87847 7.33333 4.24666C7.33333 4.61485 7.63181 4.91333 8 4.91333Z"
          fill="currentColor"
          fillOpacity="0.87"
        />
      </g>
      <defs>
        <clipPath id="clip0_18797_18328">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
